import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const EyeOffIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uE8F5'}</MuiIcon>
        );
    })
